import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faClock,
  faCalendarAlt,
  faTimes,
  faInfoCircle,
  faCheck,
  faChevronLeft,
  faChevronRight,
  faCar
} from '@fortawesome/free-solid-svg-icons';
import Footer from '../../Footer/Footer';
import { theme } from '../../../styles/theme';

// Import placeholder image - replace with actual shop image
// Import custom hook to force retail section
import { useRetailSection } from '../../../hooks/useRetailSection';

const retailImage = 'https://BelvoirCastle.b-cdn.net/Retail%20village/Duchess%20Collection/Belvoir%20retail%20village-31.webp';

const retailBanner = 'https://BelvoirCastle.b-cdn.net/Retail%20village/Duchess%20Collection/BelvoirJune26-SamChurchill-213.webp';
const duchessLogo = 'https://BelvoirCastle.b-cdn.net/Retail%20village/Duchess%20Collection/The%20Duchess%20Collection%20Off%20White.webp';
const introImage = 'https://BelvoirCastle.b-cdn.net/Retail%20village/Duchess%20Collection/C5509.00_09_47_20.Still016.webp';

const STOCK_PHOTOS = [
  {
    id: '211',
    name: 'Armchair with a blue cushion and throw',
    src: 'https://BelvoirCastle.b-cdn.net/Retail%20village/Duchess%20Collection/BelvoirJune26-SamChurchill-211.webp'
  },
  {
    id: '212',
    name: 'Orchid and a blue and white vase',
    src: 'https://BelvoirCastle.b-cdn.net/Retail%20village/Duchess%20Collection/BelvoirJune26-SamChurchill-212.webp'
  },
  {
    id: '213',
    name: 'The shop floor',
    src: 'https://BelvoirCastle.b-cdn.net/Retail%20village/Duchess%20Collection/BelvoirJune26-SamChurchill-213.webp'
  },
  {
    id: '218',
    name: 'Mirrors, jars and a bench',
    src: 'https://BelvoirCastle.b-cdn.net/Retail%20village/Duchess%20Collection/BelvoirJune26-SamChurchill-218.webp'
  },
  {
    id: '219',
    name: 'Ottoman with books and a tray',
    src: 'https://BelvoirCastle.b-cdn.net/Retail%20village/Duchess%20Collection/BelvoirJune26-SamChurchill-219.webp'
  },
  {
    id: '222',
    name: 'Fabric books',
    src: 'https://BelvoirCastle.b-cdn.net/Retail%20village/Duchess%20Collection/BelvoirJune26-SamChurchill-222.webp'
  },
  {
    id: '224',
    name: 'Lights, mirrors and prints',
    src: 'https://BelvoirCastle.b-cdn.net/Retail%20village/Duchess%20Collection/BelvoirJune26-SamChurchill-224.webp'
  },
  {
    id: '229',
    name: 'A laid table',
    src: 'https://BelvoirCastle.b-cdn.net/Retail%20village/Duchess%20Collection/BelvoirJune26-SamChurchill-229.webp'
  },
  {
    id: '230',
    name: 'Little Greene paint',
    src: 'https://BelvoirCastle.b-cdn.net/Retail%20village/Duchess%20Collection/BelvoirJune26-SamChurchill-230.webp'
  },
  {
    id: '231',
    name: 'Little Greene paint pots',
    src: 'https://BelvoirCastle.b-cdn.net/Retail%20village/Duchess%20Collection/BelvoirJune26-SamChurchill-231.webp'
  },
  {
    id: '220',
    name: 'Wallpaper samples',
    src: 'https://BelvoirCastle.b-cdn.net/Retail%20village/Duchess%20Collection/BelvoirJune26-SamChurchill-220.webp'
  },
  {
    id: '7297',
    name: 'Home fragrance and soap',
    src: 'https://BelvoirCastle.b-cdn.net/Retail%20village/Duchess%20Collection/IMG_7297.webp'
  },
  {
    id: '7307',
    name: 'Botanical hand wash and soap',
    src: 'https://BelvoirCastle.b-cdn.net/Retail%20village/Duchess%20Collection/IMG_7307.webp'
  },
  {
    id: '7337',
    name: 'Patterned robes and kaftans',
    src: 'https://BelvoirCastle.b-cdn.net/Retail%20village/Duchess%20Collection/IMG_7337.webp'
  },
  {
    id: 'fruit',
    name: 'Framed fruit studies',
    src: 'https://BelvoirCastle.b-cdn.net/Retail%20village/Duchess%20Collection/Photo%2030-12-2025%2C%2014%2027%2001.webp'
  },
  {
    id: 'peacock',
    name: 'Framed peacock print',
    src: 'https://BelvoirCastle.b-cdn.net/Retail%20village/Duchess%20Collection/Photo%2030-12-2025%2C%2014%2036%2032.webp'
  },
  {
    id: 'birds',
    name: 'Framed birds of paradise print',
    src: 'https://BelvoirCastle.b-cdn.net/Retail%20village/Duchess%20Collection/Photo%2030-12-2025%2C%2014%2037%2038.webp'
  },
  {
    id: '7659',
    name: 'Lamp and botanical prints',
    src: 'https://BelvoirCastle.b-cdn.net/Retail%20village/Duchess%20Collection/IMG_7659.webp',
    turn: 270
  },
  {
    id: '7676',
    name: 'Blue and white jars and a zebra print',
    src: 'https://BelvoirCastle.b-cdn.net/Retail%20village/Duchess%20Collection/IMG_7676.webp'
  },
  {
    id: 'still116',
    name: 'Browsing the clothing rail',
    src: 'https://BelvoirCastle.b-cdn.net/Retail%20village/Duchess%20Collection/C5509.00_44_14_05.Still116.webp'
  },
  {
    id: 'still017',
    name: 'A handbag, a white dress and the clothing rail',
    src: 'https://BelvoirCastle.b-cdn.net/Retail%20village/Duchess%20Collection/C5509.00_09_53_23.Still017.webp'
  }
];

const OFFERINGS = [
  {
    title: 'Luxury Homeware',
    text: 'Exquisite home accessories including cushions, throws, and tableware that bring the elegance of Belvoir Castle into your living space.',
    photos: [STOCK_PHOTOS[0], STOCK_PHOTOS[4], STOCK_PHOTOS[7]],
  },
  {
    title: 'Heritage-Inspired Designs',
    text: 'Each piece tells a story, with patterns and motifs drawn from the castle\'s architecture, gardens, and centuries of history.',
    photos: [STOCK_PHOTOS[17], STOCK_PHOTOS[15], STOCK_PHOTOS[18]],
  },
  {
    title: 'Elegant Apparel',
    text: 'Timeless fashion pieces including scarves, wraps, and accessories crafted from the finest materials and featuring designs inspired by the castle\'s art collection.',
    photos: [STOCK_PHOTOS[19], STOCK_PHOTOS[20], STOCK_PHOTOS[13]],
  },
  {
    title: 'Bring Belvoir Home',
    text: 'Shop wallpapers, paints and home accessories inspired by the colours, patterns and interiors of Belvoir Castle.',
    photos: [STOCK_PHOTOS[10], STOCK_PHOTOS[8], STOCK_PHOTOS[11]],
  },
];

const LOOP_SLIDES = [
  { ...OFFERINGS[OFFERINGS.length - 1], key: 'loop-last' },
  ...OFFERINGS.map((story) => ({ ...story, key: story.title })),
  { ...OFFERINGS[0], key: 'loop-first' },
];

const DuchessContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: ${props => props.theme.colors.offWhite};
  padding-top: 120px;
`;

const Hero = styled.section`
  position: relative;
  min-height: calc(100dvh - 120px);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  color: #fff;
`;

const HeroImage = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
`;

const HeroOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to top,
    rgba(16, 29, 64, 0.9) 0%,
    rgba(16, 29, 64, 0.5) 34%,
    rgba(16, 29, 64, 0.12) 64%,
    rgba(16, 29, 64, 0.2) 100%
  );
`;

const HeroInner = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: clamp(2.5rem, 6vw, 4.5rem) 1.5rem clamp(3rem, 7vw, 4.75rem);
  text-align: center;
`;

const HeroHeading = styled.h1`
  margin: 0 0 0.85rem;
`;

const HeroLogo = styled.img`
  display: block;
  width: min(380px, 78vw);
  height: auto;
  filter:
    drop-shadow(0 1px 1px rgba(0, 0, 0, 0.85))
    drop-shadow(0 4px 10px rgba(0, 0, 0, 0.7))
    drop-shadow(0 14px 28px rgba(0, 0, 0, 0.55));
`;

const HeroSubtitle = styled.p`
  margin: 0 0 2.35rem;
  max-width: 36rem;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: clamp(0.69rem, 1.2vw, 0.8125rem);
  font-weight: 500;
  letter-spacing: 0.32em;
  text-transform: uppercase;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.82);
  text-shadow:
    0 1px 1px rgba(0, 0, 0, 0.85),
    0 4px 10px rgba(0, 0, 0, 0.7),
    0 14px 28px rgba(0, 0, 0, 0.55);
`;

const ExploreButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 3.1rem;
  padding: 0.9rem 1.7rem;
  border: 1px solid rgba(255, 255, 255, 0.55);
  background: transparent;
  color: #fff;
  text-decoration: none;
  font-family: system-ui, -apple-system, sans-serif;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;

  &:hover {
    border-color: #fff;
    background: rgba(255, 255, 255, 0.08);
  }
`;

const PageInner = styled.div`
  box-sizing: border-box;
  max-width: 1120px;
  margin: 0 auto;
  padding: 0 2rem;

  @media (max-width: 768px) {
    padding: 0 1.25rem;
  }
`;

const Band = styled.section`
  scroll-margin-top: 120px;
  padding: ${props => props.$open ? '4.25rem 0 4.75rem' : props.$tight ? '3.5rem 0 3.75rem' : '4.75rem 0'};
  border-top: ${props => props.$rule ? '1px solid rgba(16, 29, 64, 0.1)' : '0'};

  @media (max-width: 768px) {
    padding: ${props => props.$open ? '2.75rem 0 3rem' : '3rem 0'};
  }
`;

const SectionHead = styled.div`
  display: grid;
  grid-template-columns: minmax(16rem, 0.8fr) minmax(18rem, 1.2fr);
  gap: 1.25rem 4.5rem;
  align-items: start;
  margin-bottom: ${props => props.$end ? '0' : '2.75rem'};

  @media (max-width: 860px) {
    grid-template-columns: 1fr;
    gap: 0.75rem;
    margin-bottom: 2rem;
  }
`;

const SectionTitle = styled.h2`
  font-family: ${props => props.theme.fonts.main};
  font-size: 2.85rem;
  color: ${props => props.theme.colors.primary};
  margin: 0;
  text-align: left;
  font-weight: 500;
  line-height: 1.05;

  @media (max-width: 768px) {
    font-size: 2.15rem;
  }
`;

const IntroText = styled.p`
  font-family: ${props => props.theme.fonts.main};
  font-size: ${props => props.$compact ? '1.15rem' : '1.45rem'};
  line-height: 1.65;
  color: ${props => props.theme.colors.secondary};
  max-width: ${props => props.$compact ? 'none' : '46rem'};
  margin: 0 0 ${props => props.$compact ? '0' : '2.5rem'};
  text-align: left;
`;

const IntroBox = styled.section`
  display: flex;
  flex-direction: row-reverse;
  align-items: stretch;
  margin: 0 0 2.75rem;
  overflow: hidden;
  background: ${props => props.theme.colors.primary};
  border-radius: 14px;
  box-shadow: 0 16px 40px rgba(16, 29, 64, 0.08);

  p {
    flex: 1;
    margin: 0;
    padding: clamp(1.5rem, 2.6vw, 2.15rem);
    font-family: ${props => props.theme.fonts.main};
    font-size: clamp(1.05rem, 1.6vw, 1.28rem);
    line-height: 1.7;
    color: ${props => props.theme.colors.offWhite};
  }

  @media (max-width: 800px) {
    flex-direction: column;
  }
`;

const IntroFrame = styled.div`
  flex: 0 0 62%;
  width: 62%;
  align-self: stretch;
  background: ${props => props.theme.colors.accent};
  clip-path: polygon(0 0, 100% 0, 100% 100%, 26% 100%);

  @media (max-width: 800px) {
    flex: none;
    width: 100%;
    height: 280px;
    clip-path: none;
  }
`;

const IntroPhoto = styled.img`
  display: block;
  width: calc(100% - 4px);
  height: calc(100% - 4px);
  margin: 2px;
  object-fit: cover;
  object-position: center 40%;
  clip-path: polygon(2% 0, 100% 0, 100% 100%, 27% 100%);

  @media (max-width: 800px) {
    width: 100%;
    height: 100%;
    margin: 0;
    clip-path: none;
  }
`;

const ParkingList = styled.ul`
  list-style: none;
  margin: 0.9rem 0 0;
  padding: 0;

  li {
    display: flex;
    align-items: flex-start;
    gap: 0.55rem;
    color: ${props => props.theme.colors.secondary};
    font-size: 1.05rem;
    line-height: 1.45;
  }

  svg {
    margin-top: 0.18rem;
    color: ${props => props.theme.colors.accent};
    flex-shrink: 0;
  }
`;

const InfoCard = styled.div`
  position: absolute;
  z-index: 1;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  width: min(390px, 46%);
  background: rgba(16, 29, 64, 0.72);
  backdrop-filter: blur(8px);
  color: white;
  padding: 1.6rem 1.45rem 1.7rem;
  text-align: left;

  h3 {
    color: white;
  }

  p {
    margin: 0.9rem 0 0;
    font-size: 0.98rem;
    line-height: 1.6;
    color: rgba(255, 255, 255, 0.84);
  }

  @media (max-width: 800px) {
    top: auto;
    right: 0;
    bottom: 0;
    left: 0;
    transform: none;
    width: auto;
  }
`;

const BadgeStatic = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 0.5rem;
  margin-bottom: 0.9rem;
`;

const ShopStage = styled.div`
  position: relative;
  margin-top: 2.5rem;
  border-radius: 12px;
  overflow: hidden;
  aspect-ratio: 4 / 3;
  background: ${props => props.theme.colors.offWhite};

  @media (max-width: 800px) {
    aspect-ratio: 3 / 4;
    margin-top: 1.75rem;
  }
`;

const ShopPhoto = styled.button`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  padding: 0;
  border: 0;
  cursor: pointer;

  img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center bottom;
  }
`;

const StatusBadge = styled.div`
  padding: 0.5rem 1rem;
  border-radius: 20px;
  background-color: ${props => props.isOpen ? '#4CAF50' : '#F44336'};
  color: white;
  font-weight: 500;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const CardTitle = styled.h3`
  font-family: ${props => props.theme.fonts.main};
  font-size: 1.7rem;
  color: white;
  margin: 0 0 0.85rem;
  font-weight: 500;
  line-height: 1.15;
`;

const TimeInfo = styled.div`
  margin-bottom: 0;
`;

const DayLabel = styled.div`
  color: rgba(255, 255, 255, 0.72);
  font-size: 0.82rem;
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: 0.08em;
  margin-bottom: 0.35rem;
`;

const Hours = styled.div`
  color: white;
  font-family: ${props => props.theme.fonts.main};
  font-size: 2.15rem;
  font-weight: 500;
  line-height: 1.1;
`;

const Note = styled.div`
  color: rgba(255, 255, 255, 0.84);
  font-size: 0.9rem;
  font-style: italic;
  margin-top: 0.5rem;
`;

const CollectionViewport = styled.div`
  overflow: hidden;
`;

const CollectionTrack = styled.div`
  display: flex;
  transform: translateX(${props => props.$index * -100}%);
  transition: ${props => props.$motion ? 'transform 0.45s ease' : 'none'};

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

const CollectionPanel = styled.div`
  flex: 0 0 100%;
  min-width: 0;
  text-align: center;
  pointer-events: ${props => props.$active ? 'auto' : 'none'};
`;

const CollectionCopy = styled.div`
  max-width: 40rem;
  min-height: 8.5rem;
  margin: 0 auto 1.35rem;

  h3 {
    margin: 0;
    color: ${props => props.theme.colors.primary};
    font-family: ${props => props.theme.fonts.main};
    font-size: 2rem;
    font-weight: 500;
    line-height: 1.15;
  }

  h3::after {
    content: '';
    display: block;
    width: 55px;
    height: 1px;
    margin: 0.85rem auto 0.85rem;
    background: ${props => props.theme.colors.primary};
  }

  p {
    margin: 0;
    color: ${props => props.theme.colors.secondary};
    font-size: 1.05rem;
    line-height: 1.6;
  }
`;

const ImageFrame = styled.div`
  position: relative;
  padding: 0 3.4rem;
`;

const PhotoRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.85rem;

  ${props => props.$count === 1 && `
    grid-template-columns: minmax(0, 1fr);
    width: calc((100% - 1.7rem) / 3);
    margin-left: auto;
    margin-right: auto;
  `}
`;

const PhotoButton = styled.button`
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  border: 0;
  overflow: hidden;
  border-radius: 12px;
  aspect-ratio: 4 / 5;
  cursor: pointer;
  background: ${props => props.theme.colors.offWhite};
`;

const PhotoImage = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;

  ${props => props.$turn && `
    top: 50%;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 125%;
    height: 80%;
    max-width: none;
    transform: translate(-50%, -50%) rotate(${props.$turn}deg);
  `}
`;

const SlideArrow = styled.button`
  position: absolute;
  z-index: 2;
  top: 50%;
  ${props => props.$side === 'left' ? 'left: 0;' : 'right: 0;'}
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.4rem;
  height: 2.4rem;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: ${props => props.theme.colors.primary};
  color: white;
  font-size: 0.9rem;
  cursor: pointer;

  &:hover {
    background: ${props => props.theme.colors.secondary};
  }
`;

const UpcomingDatesSection = styled.div`
  margin: 4rem 0;
  background-color: ${props => props.theme.colors.greyBackground};
  border-radius: 12px;
  padding: 2.5rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
`;

const UpcomingDatesTitle = styled.h3`
  font-family: ${props => props.theme.fonts.main};
  font-size: 2rem;
  color: ${props => props.theme.colors.primary};
  margin-bottom: 1.5rem;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
`;

const DatesList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
  margin-top: 2rem;
`;

const DateCard = styled.div`
  background-color: white;
  border-radius: 8px;
  padding: 1.5rem;
  border-left: 4px solid ${props => {
    if (props.$type === 'closed') return 'rgba(244, 67, 54, 0.8)';
    if (props.$type === 'special') return 'rgba(255, 165, 0, 0.8)';
    return 'rgba(34, 139, 34, 0.8)';
  }};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
`;

const DateTitle = styled.h4`
  font-family: ${props => props.theme.fonts.main};
  font-size: 1.3rem;
  color: ${props => props.theme.colors.primary};
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const DateRange = styled.div`
  font-size: 1.1rem;
  font-weight: 600;
  color: ${props => props.theme.colors.accent};
  margin-bottom: 0.8rem;
`;

const DateDetails = styled.div`
  font-size: 1rem;
  line-height: 1.6;
  color: ${props => props.theme.colors.secondary};
  margin-bottom: 0.5rem;
`;

const DateNote = styled.div`
  font-size: 0.9rem;
  font-style: italic;
  color: ${props => props.theme.colors.secondary};
  margin-top: 0.5rem;
  padding-top: 0.5rem;
  border-top: 1px solid ${props => props.theme.colors.greyBackground};
`;

const EmailSignupSection = styled.div`
  background-color: ${props => props.theme.colors.primary};
  color: white;
  padding: 4.5rem 2rem;
  text-align: center;
  width: 100%;
`;

const EmailSignupTitle = styled.h3`
  font-family: ${props => props.theme.fonts.main};
  font-size: 2.4rem;
  color: white;
  margin: 0 0 1rem;
  font-weight: 500;
`;

const EmailSignupText = styled.p`
  font-size: 1.05rem;
  line-height: 1.7;
  max-width: 620px;
  margin: 0 auto 2rem;
  color: rgba(255, 255, 255, 0.82);
`;

const EmailForm = styled.form`
  display: flex;
  max-width: 500px;
  margin: 0 auto;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
  }
`;

const EmailInput = styled.input`
  flex-grow: 1;
  padding: 0.95rem 1rem;
  border: 0;
  border-radius: 0;
  font-size: 1rem;
  min-width: 0;
  
  &:focus {
    outline: 2px solid ${props => props.theme.colors.accent};
    outline-offset: -2px;
  }
`;

const SubmitButton = styled.button`
  background-color: ${props => props.theme.colors.accent};
  color: white;
  border: 0;
  border-radius: 0;
  padding: 0.95rem 1.6rem;
  font-size: 0.95rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    background-color: #865c3c;
  }
`;

const Lightbox = styled.div`
  position: fixed;
  inset: 0;
  z-index: 2000;
  background: rgba(10, 20, 40, 0.88);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
`;

const LightboxFigure = styled.figure`
  margin: 0;
  max-width: min(1180px, 100%);
`;

const LightboxImage = styled.img`
  max-width: 100%;
  max-height: 75vh;
  object-fit: contain;
  display: block;
  background: white;
  border-radius: 12px;

  ${props => props.$turn && `
    transform: rotate(${props.$turn}deg);
    width: min(75vh, 70vw);
    max-width: none;
    max-height: none;
    height: auto;
  `}
`;

const LightboxClose = styled.button`
  position: absolute;
  top: 1.25rem;
  right: 1.25rem;
  border: 0;
  background: transparent;
  color: white;
  font-size: 2rem;
  line-height: 1;
  cursor: pointer;
`;

const DuchessCollection = () => {
  const [currentTime, setCurrentTime] = useState(new Date());
  const [email, setEmail] = useState('');
  const [activePhoto, setActivePhoto] = useState(null);
  const [section, setSection] = useState(1);
  const [sectionMotion, setSectionMotion] = useState(true);
  const sectionResetting = useRef(false);
  
  // Use custom hook to ensure we stay in retail section
  useRetailSection();

  const showCollection = (delta) => {
    if (sectionResetting.current) return;
    setSectionMotion(true);
    setSection((current) => current + delta);
  };

  useEffect(() => {
    const firstClone = OFFERINGS.length + 1;
    if (section !== 0 && section !== firstClone) return undefined;

    sectionResetting.current = true;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const timer = window.setTimeout(() => {
      setSectionMotion(false);
      setSection(section === firstClone ? 1 : OFFERINGS.length);
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          setSectionMotion(true);
          sectionResetting.current = false;
        });
      });
    }, reduceMotion ? 0 : 450);

    return () => window.clearTimeout(timer);
  }, [section]);
  
  // Update current time every minute
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 60000);
    
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (!activePhoto) return undefined;

    const onKeyDown = (event) => {
      if (event.key === 'Escape') setActivePhoto(null);
    };

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [activePhoto]);
  
  // Format current time
  const formattedTime = currentTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  const currentDay = currentTime.toLocaleDateString('en-US', { weekday: 'long' });
  
  // Get dynamic opening hours based on current date
  const getOpeningHours = () => {
    const currentDate = new Date();
    const day = currentDate.getDate();
    const month = currentDate.getMonth();
    const year = currentDate.getFullYear();
    
    // Christmas Day - Closed
    if (year === 2025 && month === 11 && day === 25) {
      return {
        days: "Closed",
        times: "Closed",
        note: "Christmas Day - Closed"
      };
    }
    
    // Boxing Day (Dec 26, 2025) - 9am-3:30pm
    if (year === 2025 && month === 11 && day === 26) {
      return {
        days: "Boxing Day",
        times: "09:00 - 15:30",
        note: "Special Boxing Day hours"
      };
    }
    
    // New Year's Day (Jan 1, 2026) - 9am-3:30pm
    if (year === 2026 && month === 0 && day === 1) {
      return {
        days: "New Year's Day",
        times: "09:00 - 15:30",
        note: "Special New Year's Day hours"
      };
    }
    
    // Default: Open daily 9am-5pm
    return {
      days: "Daily",
      times: "09:00 - 17:00",
      note: ""
    };
  };
  
  const openingHours = getOpeningHours();
  
  // Function to check if the shop is currently open
  const isShopOpen = () => {
    const currentDate = new Date();
    const day = currentDate.getDate();
    const month = currentDate.getMonth();
    const year = currentDate.getFullYear();
    
    // Christmas Day - Closed
    if (year === 2025 && month === 11 && day === 25) {
      return false;
    }
    
    // Parse opening hours
    const timeRange = openingHours.times.split('-').map(t => t.trim());
    if (timeRange.length !== 2 || timeRange[0] === 'Closed') return false;
    
    // Convert times to 24-hour format for comparison
    const [openHour, openMinute] = timeRange[0].split(':').map(Number);
    const [closeHour, closeMinute] = timeRange[1].split(':').map(Number);
    
    const openTime = new Date();
    openTime.setHours(openHour, openMinute || 0, 0);
    
    const closeTime = new Date();
    closeTime.setHours(closeHour, closeMinute || 0, 0);
    
    // Check if current time is between open and close times
    return currentTime >= openTime && currentTime <= closeTime;
  };
  
  const handleEmailSubmit = (e) => {
    e.preventDefault();
    // In a real implementation, this would send the email to a database or service

    alert('Thank you for your interest! We\'ll notify you when our online shop launches.');
    setEmail('');
  };
  
  return (
    <DuchessContainer>
      <Hero>
        <HeroImage src={retailBanner} alt="" />
        <HeroOverlay />
        <HeroInner>
          <HeroHeading>
            <HeroLogo src={duchessLogo} alt="The Duchess Collection" />
          </HeroHeading>
          <HeroSubtitle>Elegant fashion and homeware inspired by Belvoir Castle</HeroSubtitle>
          <ExploreButton
            href="#collection"
            onClick={(event) => {
              event.preventDefault();
              const target = document.getElementById('collection');
              if (!target) return;
              const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
              target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
            }}
          >
            Explore collection
          </ExploreButton>
        </HeroInner>
      </Hero>
      
      <Band $open id="collection">
        <PageInner>
        <IntroBox>
          <IntroFrame>
            <IntroPhoto src={introImage} alt="Inside The Duchess Collection boutique" />
          </IntroFrame>
          <p>
            The Duchess Collection offers a curated selection of elegant fashion and homeware inspired by the rich heritage and timeless beauty of Belvoir Castle.
            Each piece reflects the refined taste and style of the Duchess of Rutland, bringing a touch of castle luxury into your home and wardrobe.
            From exquisite silk scarves featuring patterns from the castle&apos;s historic wallpaper to handcrafted home accessories adorned with motifs from our
            renowned art collection, every item tells a story of Belvoir&apos;s aristocratic heritage.
          </p>
        </IntroBox>
        <ShopStage>
          <ShopPhoto
            type="button"
            aria-label="The Duchess Collection at Belvoir Retail Village"
            onClick={() => setActivePhoto({ src: retailImage, name: 'The Duchess Collection at Belvoir Retail Village' })}
          >
            <img src={retailImage} alt="" />
          </ShopPhoto>
          <InfoCard>
            <BadgeStatic>
              <StatusBadge isOpen={isShopOpen()}>
                <FontAwesomeIcon icon={faClock} />
                {formattedTime} on {currentDay}
              </StatusBadge>
              <StatusBadge isOpen={isShopOpen()}>
                {isShopOpen() ? 'Open Now' : 'Closed'}
              </StatusBadge>
            </BadgeStatic>
            <CardTitle>The Duchess Collection Opening Hours</CardTitle>
            <TimeInfo>
              <DayLabel>{openingHours.days}</DayLabel>
              <Hours>{openingHours.times}</Hours>
              <Note>{openingHours.note}</Note>
            </TimeInfo>
            <p>
              Visit The Duchess Collection in person to explore our full range of products. Located in the Retail Village at Belvoir Castle, 
              our boutique offers a welcoming atmosphere where you can discover our exclusive designs.
            </p>
          </InfoCard>
        </ShopStage>
        </PageInner>
      </Band>
        
        {/* <UpcomingDatesSection>
          <UpcomingDatesTitle>
            <FontAwesomeIcon icon={faCalendarAlt} />
            Upcoming Important Dates
          </UpcomingDatesTitle>
          <DatesList>
            <DateCard $type="special">
              <DateTitle>
                <FontAwesomeIcon icon={faInfoCircle} />
                Normal Opening Hours
              </DateTitle>
              <DateRange>Daily</DateRange>
              <DateDetails>
                <strong>The Duchess Collection:</strong> 9:00am - 5:00pm daily
              </DateDetails>
            </DateCard>
            
            <DateCard $type="closed">
              <DateTitle>
                <FontAwesomeIcon icon={faTimes} />
                Christmas Day
              </DateTitle>
              <DateRange>Thursday 25th December 2025</DateRange>
              <DateDetails>
                <strong>Closed</strong>
              </DateDetails>
              <DateNote>We will be closed for Christmas Day</DateNote>
            </DateCard>
            
            <DateCard $type="special">
              <DateTitle>
                <FontAwesomeIcon icon={faInfoCircle} />
                Boxing Day
              </DateTitle>
              <DateRange>Friday 26th December 2025</DateRange>
              <DateDetails>
                <strong>The Duchess Collection:</strong> 9:00am - 3:30pm
              </DateDetails>
              <DateNote>Special Boxing Day hours - early closing at 3:30pm</DateNote>
            </DateCard>
            
            <DateCard $type="special">
              <DateTitle>
                <FontAwesomeIcon icon={faInfoCircle} />
                New Year's Day
              </DateTitle>
              <DateRange>Thursday 1st January 2026</DateRange>
              <DateDetails>
                <strong>The Duchess Collection:</strong> 9:00am - 3:30pm
              </DateDetails>
              <DateNote>Special New Year's Day hours - early closing at 3:30pm</DateNote>
            </DateCard>
            
            <DateCard $type="special">
              <DateTitle>
                <FontAwesomeIcon icon={faCheck} />
                Online Boutique
              </DateTitle>
              <DateRange>Now Available</DateRange>
              <DateDetails>
                <strong>Online Shop:</strong> Browse and purchase our exclusive collection online
              </DateDetails>
              <DateNote>Shop our elegant fashion and homeware pieces from anywhere in the world</DateNote>
            </DateCard>
          </DatesList>
        </UpcomingDatesSection> */}
        
      <Band $rule>
        <PageInner>
        <SectionHead>
          <SectionTitle>Our Collections</SectionTitle>
          <IntroText $compact>
            The Duchess Collection features carefully crafted fashion and homeware pieces that embody the elegance and heritage of Belvoir Castle, 
            with designs inspired by the castle's rich history and stunning surroundings.
          </IntroText>
        </SectionHead>
        <CollectionViewport>
          <CollectionTrack $index={section} $motion={sectionMotion}>
            {LOOP_SLIDES.map((story, index) => (
              <CollectionPanel key={story.key} $active={index === section}>
                <CollectionCopy>
                  <h3>{story.title}</h3>
                  <p>{story.text}</p>
                </CollectionCopy>
              </CollectionPanel>
            ))}
          </CollectionTrack>
        </CollectionViewport>
        <ImageFrame>
          <SlideArrow
            type="button"
            $side="left"
            aria-label="Previous collection"
            onClick={() => showCollection(-1)}
          >
            <FontAwesomeIcon icon={faChevronLeft} />
          </SlideArrow>
          <CollectionViewport>
            <CollectionTrack $index={section} $motion={sectionMotion}>
              {LOOP_SLIDES.map((story, index) => (
                <CollectionPanel key={story.key} $active={index === section}>
                  <PhotoRow $count={story.photos.length}>
                    {story.photos.map((photo) => (
                      <PhotoButton
                        key={photo.id}
                        type="button"
                        aria-label={photo.name}
                        onClick={() => setActivePhoto(photo)}
                      >
                        <PhotoImage src={photo.src} alt="" loading="lazy" $turn={photo.turn} />
                      </PhotoButton>
                    ))}
                  </PhotoRow>
                </CollectionPanel>
              ))}
            </CollectionTrack>
          </CollectionViewport>
          <SlideArrow
            type="button"
            $side="right"
            aria-label="Next collection"
            onClick={() => showCollection(1)}
          >
            <FontAwesomeIcon icon={faChevronRight} />
          </SlideArrow>
        </ImageFrame>
        </PageInner>
      </Band>

      <Band $tight>
        <PageInner>
          <SectionHead $end>
            <SectionTitle>Visit Our Boutique</SectionTitle>
            <div>
              <IntroText $compact>
                While you wait for our online shop, we invite you to visit The Duchess Collection boutique in person.
                Located in the Retail Village at Belvoir Castle, our shop offers a curated selection of elegant fashion and homeware pieces
                that embody the timeless beauty and heritage of the castle.
              </IntroText>
              <ParkingList>
                <li>
                  <FontAwesomeIcon icon={faCar} />
                  Free parking for up to 2.5 hours, beside the shops
                </li>
              </ParkingList>
            </div>
          </SectionHead>
        </PageInner>
      </Band>

        {activePhoto && (
          <Lightbox onClick={() => setActivePhoto(null)} role="dialog" aria-modal="true" aria-label={activePhoto.name}>
            <LightboxClose type="button" aria-label="Close" onClick={() => setActivePhoto(null)}>×</LightboxClose>
            <LightboxFigure onClick={(event) => event.stopPropagation()}>
              <LightboxImage src={activePhoto.src} alt={activePhoto.name} $turn={activePhoto.turn} />
            </LightboxFigure>
          </Lightbox>
        )}

        <EmailSignupSection>
          <EmailSignupTitle>Be the First to Know</EmailSignupTitle>
          <EmailSignupText>
            Sign up to receive updates about our online shop launch and be the first to access our exclusive collection of fashion and homeware pieces online. 
            As a subscriber, you'll receive early access to new collections and special offers.
          </EmailSignupText>
          <EmailForm onSubmit={handleEmailSubmit}>
            <EmailInput 
              type="email" 
              placeholder="Your email address" 
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <SubmitButton type="submit">Notify Me</SubmitButton>
          </EmailForm>
        </EmailSignupSection>
      
      <Footer />
    </DuchessContainer>
  );
};

export default DuchessCollection;
